import { Component, Input } from '@angular/core';
import { IExtendedAdditionalBundleSet } from '../../interfaces/additional-bundles.interface';

@Component({
  selector: 'order-details-data-slot',
  templateUrl: './order-details-data-slot.component.html',
})
export class OrderDetailsDataSlotComponent {
  public additionalBundles: IExtendedAdditionalBundleSet;

  @Input() set bundles(bundles: IExtendedAdditionalBundleSet) {
    this.additionalBundles = bundles;
  }
}
